/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Use_PageInputs */

const en_mobile_scan_use_page = /** @type {(inputs: Mobile_Scan_Use_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use page`)
};

const es_mobile_scan_use_page = /** @type {(inputs: Mobile_Scan_Use_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar página`)
};

/**
* | output |
* | --- |
* | "Use page" |
*
* @param {Mobile_Scan_Use_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_use_page = /** @type {((inputs?: Mobile_Scan_Use_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Use_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_use_page(inputs)
	return en_mobile_scan_use_page(inputs)
});